import React from "react";

/**
 * Pricing Section Component
 * Price and package charge fields
 */
const PricingSection = ({
  formData,
  setFormData,
  errors,
  disabled,
  currencySymbol,
  hidePrice = false,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="mb-3 flex flex-wrap gap-3">

      {/* Price Field - hidden once Multiple Variants is on, since each
          variant has its own price instead of this one shared field */}
      {!hidePrice && (
        <div className="w-full sm:w-40">
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Price *
          </label>

          <div
            className={`flex items-center border rounded-lg transition-colors ${
              errors.price
                ? "border-red-500"
                : "border-gray-300 focus-within:border-blue-500"
            } ${
              disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"
            } focus-within:ring-2 focus-within:ring-blue-500`}
          >
            <span className="px-2 text-gray-600 font-medium bg-gray-50 border-r">
              {currencySymbol}
            </span>

            <input
              type="text"
              inputMode="decimal"
              className="w-full px-2 py-2 outline-none bg-transparent"
              value={formData.price}
              onChange={handleChange}
              name="price"
              disabled={disabled}
              placeholder="0.00"
            />
          </div>

          {errors.price && (
            <p className="mt-1 text-sm text-red-600">{errors.price}</p>
          )}
        </div>
      )}

      {/* Package Charge Field */}
      <div className="w-full sm:w-40">
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Package Charge{" "}
          <span className="text-gray-500 text-xs">
            {hidePrice ? "(default for variants)" : "(optional)"}
          </span>
        </label>

        <div
          className={`flex items-center border rounded-lg transition-colors border-gray-300 ${
            disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"
          } focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500`}
        >
          <span className="px-2 text-gray-600 font-medium bg-gray-50 border-r">
            {currencySymbol}
          </span>

          <input
            type="text"
            inputMode="decimal"
            className="w-full px-2 py-2 outline-none bg-transparent"
            value={formData.packageCharge}
            onChange={handleChange}
            name="packageCharge"
            disabled={disabled}
            placeholder="0.00"
          />
        </div>
      </div>

      {/* Kitchen prep time */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Prep time{" "}
          <span className="text-gray-500 text-xs">(minutes, optional)</span>
        </label>
        <input
          type="number"
          min="1"
          max="240"
          inputMode="numeric"
          className={`w-full px-4 py-3 border border-gray-300 rounded-lg outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
            disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"
          }`}
          value={formData.prepTimeMin ?? ""}
          onChange={handleChange}
          name="prepTimeMin"
          disabled={disabled}
          placeholder="Category / kitchen default"
        />
        <p className="mt-1 text-xs text-gray-500">
          {formData.prepSamples >= 3 && formData.learnedPrepMin
            ? `Kitchen is using ${Math.round(formData.learnedPrepMin)} min, learned from ${formData.prepSamples} orders.`
            : formData.prepSamples > 0 && formData.learnedPrepMin
              ? `Learned so far: ~${Math.round(formData.learnedPrepMin)} min from ${formData.prepSamples} order${formData.prepSamples === 1 ? "" : "s"} (used from 3).`
              : "Used for the kitchen waiting time until the real time is learned."}
        </p>
      </div>
    </div>
  );
};

export default PricingSection;